
import strings from "@/strings"

export const getChartLoanding = ({ chartLoanding }) => chartLoanding;
export const getChartList = ({ chartList }) => chartList;
export const getChart = ({ chart }) => chart;
export const getApis = ({ apis }) => apis;
export const getApi = ({ api }) => api;
export const getNameApi = ({ api }) => api.name ? api.name : '';
export const getApprovalApi = ({ api }) => api.approval ? api.approval : '';
export const getGroupList = ({ api }) => api.groupsApi;
export const getPlanList = ({ api }) => api.plansApi;
export const getEndpointsApi = ({ api }) => api.endpointsApi;
export const isRequired = ({ api }) => api && api.status == !strings.apiStatusValue.inRegistration;
export const isInvisivel = ({ api }) => api && api.status == strings.apiStatusValue.invisible.value;
export const isEdited = ({ api }) => api && api.status == strings.apiStatusValue.inRegistration;
export const isPublished = ({ api }) => api && api.status == strings.apiStatusValue.published.value;
export const getBusinessModelType = ({ businessModelType }) => businessModelType;
export const getSwaggerDados = ({ swaggerDados }) => swaggerDados;
export const getMateriaisUteis = ({ materiaisUteis }) => materiaisUteis;
export const getRegisterApiTab = ({ registerApiTab }) => registerApiTab;
export const getRecentlyChangedApi = ({ recentlyChangedApi }) => recentlyChangedApi;
export const isApiDetailsLoading = ({ apiDetailsLoading }) => apiDetailsLoading;